//import logo from './logo.svg';
//import './App.css';
import React, {useEffect} from 'react';
import {getUsers} from './actions/users'
import {getDevices} from './actions/devices'
import {createUsers} from './actions/users'

import ReactDOM from 'react-dom'
//import {Container, AppBar, Typography, Grow, Grid} from '@material-ui/core';
import { styled, createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import MuiDrawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Badge from '@mui/material/Badge';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import MyLink from '@mui/material/Link';
import MenuIcon from '@mui/icons-material/Menu';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Alert from '@mui/material/Alert';


import FormControlLabel from '@mui/material/FormControlLabel';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import NotificationsIcon from '@mui/icons-material/Notifications';
import ChartsEmbedSDK from "@mongodb-js/charts-embed-dom";
import { mainListItems, secondaryListItems } from './listItems';

import LineChart from './lineChart';
import UserList from './userList';
import Odors from './odorTracker';
import MapDevice from './mapDevice';
import LeafMap from './leafMap';
import Legend from './Legend';
import logo from './logos/JustAirLogo1.png'
import {useDispatch, useSelector} from 'react-redux'
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useNavigate
} from "react-router-dom";


function Copyright(props) {
  return (
    <Typography variant="body2" color="text.secondary" align="center" {...props}>
      {'Copyright © '}
      <MyLink color="inherit" href="https://justair.co/">
        JustAir Solutions
      </MyLink>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const theme = createTheme();

const SignUp = () => {

  let navigate = useNavigate();
  useEffect(() => {
    dispatch(getUsers());
  }, []);


  const users = useSelector((state) => state.users);
  const userNumbers = [...new Set(users.map(u => u.phone))];
  const dispatch = useDispatch();

  const [numberExist, setNumberExist] = React.useState(false);
  const [isSubmitted, setIsSubmitted] = React.useState(false);
  const [validPhone, setValidPhone] = React.useState(false);
  const [btnDisabled, setBtnDisabled] = React.useState(true);
  const [validCode, setValidCode] = React.useState(false);



  const handleInputPhone = (e) => {
    const { name, value } = e.target;
    var data = new FormData(e.currentTarget);
    var signText = data.get('signCode').replace(/\s/g, "").toLowerCase();
    var signCodes = ["airgr1", "airgr2", "airgr3", "airgr4", "airgr5"]
    var phoneno = /^\d{10}$/;
    if(data.get('phone').match(phoneno)){

      setValidPhone(true)
      }
      else{ setValidPhone(false)
          setBtnDisabled(true)
      }

  if (signCodes.indexOf(signText)>-1){
        setValidCode(true)
        setBtnDisabled(false)

    }else{
        setValidCode(false)
        setBtnDisabled(true)
    }

    if(validCode && validPhone){
      setBtnDisabled(false)
    }


  };

  const handleSubmit = (event) => {
     event.preventDefault();

     var data = new FormData(event.currentTarget);


     if(userNumbers.includes("+1"+data.get('phone')))
     {

       setNumberExist(true)
     }else{

       var userData = {phone: data.get('phone'), alertPhone:"+16164219952", signCode:data.get('signCode')}

        dispatch(createUsers(userData))
        setIsSubmitted(true)
     }

   };





   return (
     <ThemeProvider theme={theme}>
       <Container component="main" maxWidth="xs">
         <CssBaseline />
         <Box
           sx={{
             marginTop: 8,
             display: 'flex',
             flexDirection: 'column',
             alignItems: 'center',
           }}
         >
           <img src={logo} height={"50"}/>


           <Typography component="h1" variant="h4" align="center">
             Sign up for Grand Rapids Local Air Quality Alerts
           </Typography>
              <Typography align="center">
             We are currently launched in Downtown Grand Rapids.<br/> Please use Neighborhood Code <b>airgr1</b>.
             </Typography>
          {  numberExist && <Alert severity="warning">This phone number is already subscribed</Alert>}

           {
             !isSubmitted ?
           <Box component="form" noValidate  onChange={handleInputPhone} onSubmit={handleSubmit} sx={{ mt: 3 }}>
             <Grid container spacing={2}>

              <Grid item xs={12}>
                 <TextField
                   required
                   fullWidth
                   id="phone"
                   label="phone"
                   name="phone"
                   autoComplete="phone"
                   helperText="Please use the following phone format 1234567890"

                 />

               </Grid>


               <Grid item xs={12}>
                 <TextField
                   required
                   fullWidth
                   name="signCode"
                   label="Neighborhood Code"
                   id="signCode"
                   helperText="Neighborhood Codes: airgr1, airgr2, airgr3, airgr4, airgr5"
                 />
               </Grid>
               <Grid item xs={12}>

               </Grid>
             </Grid>
             <Button
               type="submit"
               fullWidth
               variant="contained"
               sx={{ mt: 3, mb: 2 }}
               disabled={btnDisabled}
             >
               Sign Up
             </Button>

           </Box>
           :
              <Grid direction="column" container xs={12} style={{ minHeight: '50vh' }} alignItems="center"
  justifyContent="center" sx={{ textAlign: 'center' }}>
              <Typography component="h2" variant="h5"  sx={{ m: 2 }}>
                Thank you for signing up to JustAir Air Quality Alerts!
              </Typography>
              <Typography component="h2" variant="h5">
                Please feel free to visit your Local Air Quality Dashboard
              </Typography>

              <Button

                onClick={() => {

              navigate("/");
            }}
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
              >
              Go to Dashboard
              </Button>
            </Grid>
           }
         </Box>
         <Copyright sx={{ mt: 5 }} />
       </Container>
     </ThemeProvider>
   );

}

export default SignUp;
